import React, { useEffect, useRef, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { handleGetRequest } from '../../service/GetTemplate';
import { handlePostRequest } from '../../service/PostTemplate';
import { handlePutRequest } from '../../service/PutTemplate';
import { endPoints } from '../../Config';
import { useDispatch } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import SecuredFileChange from '../../components/SecuredFileChange';

const AddEditCustomers = ({ editable, viewable, onHide, rowRecord, onCancel }) => {
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    const genderOptions = [
        { name: 'Male', id: 'male' },
        { name: 'Female', id: 'female' }
    ];

    const customerImageRef = useRef(null);

    const dispatch = useDispatch();

    const validationSchema = Yup.object().shape({
        customerName: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required')
            .matches(/^[a-zA-Z0-9\s]*$/, 'Name must contain only alphanumeric values'),

        phoneNumber: Yup.string()
            .matches(/^\d+$/, 'Phone number should only contain numbers')
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required'),

        consumerId: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required'),

        dateOfBirth: Yup.string().required('This field is required'),

        cnic: Yup.string()
            .matches(/^\d+$/, 'Cnic should only contain numbers')
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required'),

        gender: Yup.string().required('This field is required'),

        emailAddress: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .email('Invalid email')
            .required('This field is required'),
        address: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required'),
        profileImageBase64: Yup.string().required('This field is required')
    });
    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            id: '',
            customerName: '',
            phoneNumber: '',
            consumerId: '',
            dateOfBirth: '',
            cnic: '',
            gender: '',
            emailAddress: '',
            address: '',
            profileImageBase64: '',
            profileImagePath: '',
            createdBy: ''
        },
        onSubmit: async (data) => {
            const user = JSON.parse(localStorage.getItem('user') || '{}');

            const formData = new FormData();
            if (!editable) {
                setLoadingBtn(true);

                formData.append('customerName', data?.customerName || '');
                formData.append('phoneNumber', data?.phoneNumber || '');
                formData.append('consumerId', data?.consumerId || '');
                formData.append('dateOfBirth', data?.dateOfBirth || '');
                formData.append('cnic', data?.cnic || '');
                formData.append('gender', data?.gender || '');
                formData.append('emailAddress', data?.emailAddress || '');
                formData.append('address', data?.address || '');
                formData.append('createdBy', user?.data?.userId || '');

                if (selectedFile) formData.append('profileImage', selectedFile);

                const response = await dispatch(handlePostRequest(formData, endPoints.addCustomer, true));
                if (response?.status === 200) {
                    formik.resetForm();
                    onHide();
                }
                setLoadingBtn(false);
            } else {
                setLoadingBtn(true);

                formData.append('id', data?.id || '');
                formData.append('customerName', data?.customerName || '');
                formData.append('phoneNumber', data?.phoneNumber || '');
                formData.append('consumerId', data?.consumerId || '');
                formData.append('dateOfBirth', data?.dateOfBirth || '');
                formData.append('cnic', data?.cnic || '');
                formData.append('gender', data?.gender || '');
                formData.append('emailAddress', data?.emailAddress || '');
                formData.append('address', data?.address || '');
                formData.append('modifiedBy', user?.data?.userId || '');

                if (selectedFile) formData.append('profileImage', selectedFile);

                const response = await dispatch(handlePutRequest(formData, endPoints.updateCustomer, true));
                if (response?.status === 200) {
                    formik.resetForm();
                    onHide();
                }
                setLoadingBtn(false);
            }
        }
    });

    const getCustomerbyId = async () => {
        setLoadingBtn(true);
        const response = await handleGetRequest(endPoints.getCustomerById(rowRecord.id), true);
        if (response) {
            const dateformat = response?.data?.dateOfBirth ? formatedDate(response?.data?.dateOfBirth) : '';
            formik.setFieldValue('dateOfBirth', dateformat);
            formik.setFieldValue('id', response?.data?.id);
            formik.setFieldValue('status', response?.data?.status);
            formik.setFieldValue('customerName', response?.data?.customerName);
            formik.setFieldValue('phoneNumber', response?.data?.phoneNumber);
            formik.setFieldValue('consumerId', response?.data?.consumerId);
            formik.setFieldValue('gender', response?.data?.gender);
            formik.setFieldValue('cnic', response?.data?.cnic);
            formik.setFieldValue('emailAddress', response?.data?.emailAddress);
            formik.setFieldValue('address', response?.data?.address);
            formik.setFieldValue('profileImageBase64', response?.data?.profileImagePath);
        }
        setLoadingBtn(false);
    };

    useEffect(() => {
        if (editable || viewable) {
            getCustomerbyId();
        }
    }, [rowRecord]);

    const handleCustomerIcon = () => {
        customerImageRef.current.click();
    };

    function handleCustomerImageChange(event) {
        setSelectedFile(null);
        formik.setFieldValue('profileImageBase64', '');
        const selectedFile = event.target.files[0];
        const fileTypes = ['image'];
        const { file: newFile, error } = SecuredFileChange(selectedFile, fileTypes);
        if (error) {
        } else if (newFile) {
            formik.setFieldValue('profileImageBase64', newFile?.name);
            setSelectedFile(newFile);
        }
    }
    function formatedDate(originalDate) {
        const createDate = new Date(originalDate);

        const year = createDate.getFullYear();
        const month = (createDate.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-based
        const day = createDate.getDate().toString().padStart(2, '0');

        return `${year}-${month}-${day}`;
    }

    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    const previousDate = currentDate.toISOString().split('T')[0];

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="grid p-fluid">
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="customerName">
                            Name <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="customerName" name="customerName" placeholder="Enter Customer Name" value={formik?.values?.customerName} maxLength={30} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.customerName && formik.errors.customerName && <small className="p-error">{formik.errors.customerName}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="phoneNumber">
                            Phone No. <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="phoneNumber" name="phoneNumber" placeholder="Enter Phone No." value={formik?.values?.phoneNumber} maxLength={11} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.phoneNumber && formik.errors.phoneNumber && <small className="p-error">{formik.errors.phoneNumber}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="consumerId">
                            Consumer ID <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="consumerId" name="consumerId" placeholder="Enter Consumer ID" value={formik?.values?.consumerId} maxLength={30} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.consumerId && formik.errors.consumerId && <small className="p-error">{formik.errors.consumerId}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="cnic">
                            CNIC <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="cnic" name="cnic" placeholder="Enter CNIC" value={formik?.values?.cnic} maxLength={13} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.cnic && formik.errors.cnic && <small className="p-error">{formik.errors.cnic}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="emailAddress">
                            Email Address <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="emailAddress" name="emailAddress" placeholder="Enter Email" value={formik?.values?.emailAddress} maxLength={30} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.emailAddress && formik.errors.emailAddress && <small className="p-error">{formik.errors.emailAddress}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="address">
                            {' '}
                            Address <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="address" name="address" placeholder="Enter Address" value={formik?.values?.address} maxLength={100} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.address && formik.errors.address && <small className="p-error">{formik.errors.address}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="gender">
                            Gender <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Dropdown
                            id="gender"
                            name="gender"
                            value={formik?.values?.gender}
                            options={genderOptions}
                            optionLabel="name"
                            optionValue="id"
                            onChange={formik.handleChange}
                            placeholder="Select Gender"
                            className="w-full"
                            disabled={viewable}
                        />
                        {formik.touched.gender && formik.errors.gender && <small className="p-error">{formik.errors.gender}</small>}
                    </div>
                </div>{' '}
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="dateOfBirth">
                            Date Of Birth <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="dateOfBirth" type="date" name="dateOfBirth" max={previousDate} value={formik?.values?.dateOfBirth || ''} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.dateOfBirth && formik.errors.dateOfBirth && <small className="p-error">{formik.errors.dateOfBirth}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-6">
                    <div className="mb-3">
                        <div className="field">
                            <label htmlFor="image">
                                Upload Image <span style={{ color: 'red' }}>*</span>
                            </label>
                            <div className="file-input-container file-input-wrapper w-100" onClick={handleCustomerIcon}>
                                <input type="file" accept="image/*" style={{ display: 'none' }} ref={customerImageRef} onChange={handleCustomerImageChange} className="file-input-field" disabled={viewable} />
                                <input type="text" placeholder="Choose a file..." value={formik?.values?.profileImageBase64} readOnly className="file-input-field" />
                            </div>
                            {formik.errors.profileImageBase64 ? <small className="p-error">{formik.errors.profileImageBase64}</small> : ''}
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex justify-content-center mt-4 gap-2">
                {!viewable && (
                    <Button label={editable ? 'Update' : 'Save'} icon={editable ? 'pi pi-pencil' : 'pi pi-save'} type="submit" disabled={loadingBtn} className="p-button-success p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} />
                )}
                <Button label="Cancel" icon="pi pi-times" type="button" className="p-button-secondary p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} onClick={() => onCancel()} />
            </div>
        </form>
    );
};

export default AddEditCustomers;
